import React, { useMemo } from "react";
import ChatTypeIcon from "../ChatTypeIcon";
import ChatMessage from "../ChatMessage";
import ChatInput from "../ChatInput";
import { addDateSeparators } from "../../../../../../utils/chatGrouper";
import style from "./ChatWindow.module.scss";

const ChatWindow = ({
  selectedChat,
  messageText,
  onMessageChange,
  onSendMessage,
  placeholder,
  t,
  messagesEndRef,
  canSendMessage = true,
  disabledMessage,
  chatFiles = {},
  isChatFilesLoading = false,
  onDownloadFile,
  onFileSelect,
  isUploading = false,
}) => {
  if (!selectedChat) {
    return <div className={style.chat_window} />;
  }

  const messagesWithFiles = useMemo(() => {
    return addDateSeparators(selectedChat.messages, t).map((item) => {
      if (item.type === "date-separator") {
        return item;
      }

      const externalFiles = chatFiles[item.id] || [];
      const messageFiles = externalFiles.length > 0 ? externalFiles : (item.files || []);

      return { ...item, files: messageFiles };
    });
  }, [selectedChat.messages, chatFiles, t]);

  return (
    <div className={style.chat_window}>
      <div className={style.chat_window_header}>
        <div className={style.chat_window_user_info}>
          <div className={style.chat_window_user_icon}>
            <ChatTypeIcon type={selectedChat.type} size={20} />
          </div>
          <div className={style.chat_window_user_details}>
            <div className={style.chat_window_user_name}>{selectedChat.name}</div>
            <div className={style.chat_window_user_role}>{selectedChat.role}</div>
          </div>
        </div>
      </div>

      <div className={style.messages_container}>
        {messagesWithFiles.map((item) => {
          if (item.type === "date-separator") {
            return (
              <div key={item.id} className={style.date_separator}>
                {item.displayDate}
              </div>
            );
          }

          return (
            <ChatMessage
              key={item.id}
              message={item}
              files={item.files || []}
              isChatFilesLoading={isChatFilesLoading}
              onDownloadFile={onDownloadFile}
              t={t}
            />
          );
        })}
        <div ref={messagesEndRef} />
      </div>

      <ChatInput
        value={messageText}
        onChange={onMessageChange}
        onSend={onSendMessage}
        placeholder={placeholder}
        disabled={!canSendMessage}
        disabledMessage={disabledMessage}
        onFileSelect={onFileSelect}
        isUploading={isUploading}
      />
    </div>
  );
};

export default ChatWindow;
